import { checkInstacartRetailer, isBeaconCriteo } from 'src/utils/app';

export enum ADVERTISING_EXPORT_TYPES {
  CLIENT = 'beaconClientId',
  AD_ENTITY = 'entityId',
  AD_PORTFOLIO = 'portfolioId',
  AD_CAMPAIGN = 'campaignId',
  PRODUCT = 'stacklineSku',
  TARGET = 'targetingText',
  AD_GROUP = 'adGroupId',
  LINE_ITEM = 'lineItemId'
}

enum SECONDARY_EXPORT_TYPE {
  NONE = '',
  AD_TYPE = 'campaignType',
  BRAND = 'brandId',
  CATEGORY = 'categoryId',
  SUB_CATEGORY = 'subCategoryId',
  TARGET = 'targetingText,targetingType',
  PRODUCT = 'stacklineSku',
  AD_GROUP_NAME = 'adGroupName'
}

const SECONDARY_DROPDOWN_OPTIONS = {
  [SECONDARY_EXPORT_TYPE.NONE]: { id: SECONDARY_EXPORT_TYPE.NONE, label: 'None', entityType: '' },
  [SECONDARY_EXPORT_TYPE.AD_TYPE]: { id: SECONDARY_EXPORT_TYPE.AD_TYPE, label: 'Campaign Type', entityType: '' },
  [SECONDARY_EXPORT_TYPE.BRAND]: { id: SECONDARY_EXPORT_TYPE.BRAND, label: 'Brand', entityType: 'brand' },
  [SECONDARY_EXPORT_TYPE.CATEGORY]: { id: SECONDARY_EXPORT_TYPE.CATEGORY, label: 'Category', entityType: 'category' },
  [SECONDARY_EXPORT_TYPE.SUB_CATEGORY]: {
    id: SECONDARY_EXPORT_TYPE.SUB_CATEGORY,
    label: 'Subcategory',
    entityType: 'subcategory'
  },
  [SECONDARY_EXPORT_TYPE.TARGET]: { id: SECONDARY_EXPORT_TYPE.TARGET, label: 'Target', entityType: 'adTarget' },
  [SECONDARY_EXPORT_TYPE.PRODUCT]: { id: SECONDARY_EXPORT_TYPE.PRODUCT, label: 'Product', entityType: 'product' },
  [SECONDARY_EXPORT_TYPE.AD_GROUP_NAME]: {
    id: SECONDARY_EXPORT_TYPE.AD_GROUP_NAME,
    label: 'None',
    entityType: ''
  }
};

export const SECONDARY_DROPDOWN = {
  [ADVERTISING_EXPORT_TYPES.CLIENT]: [
    SECONDARY_DROPDOWN_OPTIONS[SECONDARY_EXPORT_TYPE.NONE],
    SECONDARY_DROPDOWN_OPTIONS[SECONDARY_EXPORT_TYPE.AD_TYPE],
    SECONDARY_DROPDOWN_OPTIONS[SECONDARY_EXPORT_TYPE.BRAND],
    SECONDARY_DROPDOWN_OPTIONS[SECONDARY_EXPORT_TYPE.CATEGORY],
    SECONDARY_DROPDOWN_OPTIONS[SECONDARY_EXPORT_TYPE.SUB_CATEGORY]
  ],
  [ADVERTISING_EXPORT_TYPES.AD_GROUP]: [
    SECONDARY_DROPDOWN_OPTIONS[SECONDARY_EXPORT_TYPE.NONE],
    SECONDARY_DROPDOWN_OPTIONS[SECONDARY_EXPORT_TYPE.PRODUCT],
    SECONDARY_DROPDOWN_OPTIONS[SECONDARY_EXPORT_TYPE.TARGET]
  ],
  [ADVERTISING_EXPORT_TYPES.AD_ENTITY]: [
    SECONDARY_DROPDOWN_OPTIONS[SECONDARY_EXPORT_TYPE.NONE],
    SECONDARY_DROPDOWN_OPTIONS[SECONDARY_EXPORT_TYPE.AD_TYPE],
    SECONDARY_DROPDOWN_OPTIONS[SECONDARY_EXPORT_TYPE.BRAND],
    SECONDARY_DROPDOWN_OPTIONS[SECONDARY_EXPORT_TYPE.CATEGORY],
    SECONDARY_DROPDOWN_OPTIONS[SECONDARY_EXPORT_TYPE.SUB_CATEGORY],
    SECONDARY_DROPDOWN_OPTIONS[SECONDARY_EXPORT_TYPE.PRODUCT],
    SECONDARY_DROPDOWN_OPTIONS[SECONDARY_EXPORT_TYPE.TARGET]
  ],
  [ADVERTISING_EXPORT_TYPES.AD_PORTFOLIO]: [
    SECONDARY_DROPDOWN_OPTIONS[SECONDARY_EXPORT_TYPE.NONE],
    SECONDARY_DROPDOWN_OPTIONS[SECONDARY_EXPORT_TYPE.AD_TYPE],
    SECONDARY_DROPDOWN_OPTIONS[SECONDARY_EXPORT_TYPE.BRAND],
    SECONDARY_DROPDOWN_OPTIONS[SECONDARY_EXPORT_TYPE.CATEGORY],
    SECONDARY_DROPDOWN_OPTIONS[SECONDARY_EXPORT_TYPE.SUB_CATEGORY],
    SECONDARY_DROPDOWN_OPTIONS[SECONDARY_EXPORT_TYPE.PRODUCT],
    SECONDARY_DROPDOWN_OPTIONS[SECONDARY_EXPORT_TYPE.TARGET]
  ],
  [ADVERTISING_EXPORT_TYPES.AD_CAMPAIGN]: [
    SECONDARY_DROPDOWN_OPTIONS[SECONDARY_EXPORT_TYPE.NONE],
    SECONDARY_DROPDOWN_OPTIONS[SECONDARY_EXPORT_TYPE.BRAND],
    SECONDARY_DROPDOWN_OPTIONS[SECONDARY_EXPORT_TYPE.CATEGORY],
    SECONDARY_DROPDOWN_OPTIONS[SECONDARY_EXPORT_TYPE.SUB_CATEGORY],
    SECONDARY_DROPDOWN_OPTIONS[SECONDARY_EXPORT_TYPE.PRODUCT],
    SECONDARY_DROPDOWN_OPTIONS[SECONDARY_EXPORT_TYPE.TARGET]
  ],
  [ADVERTISING_EXPORT_TYPES.PRODUCT]: [
    SECONDARY_DROPDOWN_OPTIONS[SECONDARY_EXPORT_TYPE.NONE],
    SECONDARY_DROPDOWN_OPTIONS[SECONDARY_EXPORT_TYPE.TARGET]
  ],
  [ADVERTISING_EXPORT_TYPES.TARGET]: [SECONDARY_DROPDOWN_OPTIONS[SECONDARY_EXPORT_TYPE.NONE]]
};

export const getDropdownOptions = () => {
  const isCriteoRetailer = isBeaconCriteo();
  const isInstacartRetailer = checkInstacartRetailer();

  const DROPDOWN_OPTIONS: {
    id: ADVERTISING_EXPORT_TYPES;
    label: string;
    entityType: string;
    /** Product wanted to group by adGroupName  instead of id*/
    customExportId?: string;
  }[] = [
    { id: ADVERTISING_EXPORT_TYPES.CLIENT, label: 'Organization', entityType: 'client' },
    { id: ADVERTISING_EXPORT_TYPES.AD_ENTITY, label: 'Entity', entityType: 'adEntity' }
  ];

  if (isCriteoRetailer) {
    DROPDOWN_OPTIONS.push({ id: ADVERTISING_EXPORT_TYPES.LINE_ITEM, label: 'Line Item', entityType: 'lineItem' });
  } else if (!isInstacartRetailer) {
    DROPDOWN_OPTIONS.push({ id: ADVERTISING_EXPORT_TYPES.AD_PORTFOLIO, label: 'Portfolio', entityType: 'adPortfolio' });
  }

  if (isInstacartRetailer) {
    DROPDOWN_OPTIONS.push({
      id: ADVERTISING_EXPORT_TYPES.AD_GROUP,
      label: 'Ad Group',
      entityType: 'adGroup',
      customExportId: 'adGroupName'
    });
  }

  DROPDOWN_OPTIONS.push(
    { id: ADVERTISING_EXPORT_TYPES.AD_CAMPAIGN, label: 'Campaign', entityType: 'adCampaign' },
    { id: ADVERTISING_EXPORT_TYPES.PRODUCT, label: 'Product', entityType: 'product' },
    { id: ADVERTISING_EXPORT_TYPES.TARGET, label: 'Target', entityType: 'adTarget' }
  );
  return DROPDOWN_OPTIONS;
};
